<template>
  <v-card>
    <v-card-title class="d-flex align-center flex-wrap ga-2">
      <span class="text-subtitle-1 font-weight-bold">Detalii CDR</span>
      <v-spacer />
      <v-text-field
        v-model="searchTerm"
        label="Cauta CLI/CLD"
        density="compact"
        variant="outlined"
        hide-details
        clearable
        prepend-inner-icon="mdi-magnify"
        style="max-width: 220px"
        @keyup.enter="onSearch"
        @click:clear="onClearSearch"
      />
      <v-btn-toggle v-model="selectedType" density="compact">
        <v-btn size="small" value="">Toate</v-btn>
        <v-btn size="small" value="data">Date</v-btn>
        <v-btn size="small" value="sms">SMS</v-btn>
        <v-btn size="small" value="voice">Voce</v-btn>
      </v-btn-toggle>
    </v-card-title>

    <v-data-table-server
      :headers="headers"
      :items="records"
      :items-length="totalCount"
      :loading="loading"
      :items-per-page="perPage"
      :page="page"
      density="compact"
      @update:page="onPageChange"
      @update:items-per-page="onPerPageChange"
    >
      <template v-slot:[`item.start_time`]="{ item }">
        {{ formatDateTime(item.start_time) }}
      </template>
      <template v-slot:[`item.record_type`]="{ item }">
        <v-chip :color="typeColor(item.record_type)" size="small" variant="tonal">
          {{ typeLabel(item.record_type) }}
        </v-chip>
      </template>
      <template v-slot:[`item.direction`]="{ item }">
        <v-icon size="small" :color="item.direction === 'out' ? 'red' : 'green'">
          {{ item.direction === 'out' ? 'mdi-arrow-up' : 'mdi-arrow-down' }}
        </v-icon>
        {{ item.direction === 'out' ? 'OUT' : 'IN' }}
      </template>
      <template v-slot:[`item.cli`]="{ item }">
        {{ item.cli || '-' }}
      </template>
      <template v-slot:[`item.quantity`]="{ item }">
        {{ formatQuantity(item) }}
      </template>
      <template v-slot:[`item.cost`]="{ item }">
        {{ Number(item.cost || 0).toFixed(4) }} {{ item.currency || 'EUR' }}
      </template>
      <template v-slot:[`item.network_type`]="{ item }">
        <v-chip :color="networkColor(item.network_type)" size="x-small" variant="tonal">
          {{ item.network_type || '-' }}
        </v-chip>
      </template>
    </v-data-table-server>
  </v-card>
</template>

<script>
export default {
  name: 'TrafficDetailsTable',
  props: {
    records: { type: Array, default: () => [] },
    totalCount: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    page: { type: Number, default: 1 },
    perPage: { type: Number, default: 50 }
  },
  emits: ['update:page', 'update:perPage', 'update:recordType', 'update:search'],
  data() {
    return {
      selectedType: '',
      searchTerm: '',
      headers: [
        { title: 'Data/Ora', key: 'start_time', sortable: false },
        { title: 'MSISDN', key: 'msisdn', sortable: false },
        { title: 'Tip', key: 'record_type', sortable: false },
        { title: 'Directie', key: 'direction', sortable: false },
        { title: 'CLI', key: 'cli', sortable: false },
        { title: 'CLD', key: 'destination', sortable: false },
        { title: 'Cantitate', key: 'quantity', sortable: false },
        { title: 'Cost', key: 'cost', sortable: false },
        { title: 'Retea', key: 'network_type', sortable: false }
      ]
    }
  },
  watch: {
    selectedType(val) {
      this.$emit('update:recordType', val || null)
    }
  },
  methods: {
    onPageChange(p) {
      this.$emit('update:page', p)
    },
    onPerPageChange(pp) {
      this.$emit('update:perPage', pp)
    },
    onSearch() {
      this.$emit('update:search', this.searchTerm || null)
    },
    onClearSearch() {
      this.searchTerm = ''
      this.$emit('update:search', null)
    },
    formatDateTime(dt) {
      if (!dt) return '-'
      return new Date(dt).toLocaleString('ro-RO', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      })
    },
    formatQuantity(item) {
      const q = Number(item.quantity || 0)
      switch (item.record_type) {
        case 'data':
          if (q >= 1024) return (q / 1024).toFixed(2) + ' GB'
          return q.toFixed(2) + ' MB'
        case 'sms':
          return q.toFixed(0) + ' msg'
        case 'voice':
          return q.toFixed(1) + ' min'
        default:
          return q.toFixed(2)
      }
    },
    typeColor(type) {
      switch (type) {
        case 'data': return 'blue'
        case 'sms': return 'green'
        case 'voice': return 'orange'
        default: return 'grey'
      }
    },
    typeLabel(type) {
      switch (type) {
        case 'data': return 'Date'
        case 'sms': return 'SMS'
        case 'voice': return 'Voce'
        default: return type
      }
    },
    networkColor(type) {
      switch (type) {
        case 'national': return 'green'
        case 'roaming': return 'orange'
        case 'international': return 'red'
        default: return 'grey'
      }
    }
  }
}
</script>
